<template>
  <section class="contact-panel">
    <template v-if="contact">
      <header class="chat-header">
        <div>
          <h2>{{ remarkName }}</h2>
          <p>{{ username }}</p>
        </div>
      </header>

      <div class="contact-profile">
        <img v-if="contact.portrait" class="profile-avatar image-avatar" :src="contact.portrait" alt="">
        <div v-else class="profile-avatar">{{ contact.avatarText }}</div>
        <div class="profile-main">
          <div class="remark-row">
            <h3>{{ remarkName }}</h3>
            <button type="button" class="icon-button remark-edit-button" title="编辑备注名" @click="openAliasEditor">✏️</button>
          </div>
        </div>
        <dl class="profile-fields">
          <div>
            <dt>用户名</dt>
            <dd>{{ username }}</dd>
          </div>
          <div>
            <dt>手机号</dt>
            <dd>{{ mobile }}</dd>
          </div>
          <div>
            <dt>地区</dt>
            <dd>{{ address }}</dd>
          </div>
        </dl>
        <button class="primary-action profile-action" @click="contacts.openChat(contact)">发消息</button>
      </div>

      <div v-if="editingAlias" class="modal-backdrop contact-modal-backdrop" @click.self="closeAliasEditor">
        <form class="modal-panel" @submit.prevent="submitAlias">
          <header>
            <strong>编辑备注名</strong>
            <button type="button" class="icon-button" title="关闭" @click="closeAliasEditor">×</button>
          </header>
          <label>
            <span>备注名</span>
            <input v-model.trim="aliasDraft" maxlength="32" autocomplete="off" autofocus>
          </label>
          <p v-if="aliasError" class="form-error">{{ language.error(aliasError) }}</p>
          <div class="modal-actions">
            <button type="button" class="ghost-inline-action" :disabled="aliasSaving" @click="closeAliasEditor">取消</button>
            <button type="submit" class="primary-inline-action" :disabled="aliasSaving">{{ aliasSaving ? '保存中' : '保存' }}</button>
          </div>
        </form>
      </div>
    </template>

    <div v-else class="empty-chat">
      <strong>选择一个联系人</strong>
      <span>好友列表同步完成后，可以在左侧查看资料</span>
    </div>
  </section>
</template>

<script setup>
import { useLanguageStore } from '@/stores/language';
const language = useLanguageStore();
import { computed, ref, watch } from 'vue';
import { useContactStore } from '@/stores/contacts';

const contacts = useContactStore();
const contact = computed(() => contacts.activeContact);
const remarkName = computed(() => contact.value?.alias || '未设置');
const username = computed(() => contact.value?.rawUser?.displayName || contact.value?.rawUser?.name || contact.value?.uid || '');
const mobile = computed(() => contact.value?.rawUser?.mobile || '未知');
const address = computed(() => contact.value?.rawUser?.address || '未知');
const editingAlias = ref(false);
const aliasDraft = ref('');
const aliasSaving = ref(false);
const aliasError = ref('');

watch(contact, () => {
  editingAlias.value = false;
  aliasError.value = '';
});

function openAliasEditor() {
  aliasDraft.value = contact.value?.alias || '';
  aliasError.value = '';
  editingAlias.value = true;
}

function closeAliasEditor() {
  if (aliasSaving.value) {
    return;
  }
  editingAlias.value = false;
  aliasError.value = '';
}

async function submitAlias() {
  if (!contact.value) {
    return;
  }
  aliasSaving.value = true;
  aliasError.value = '';
  const ok = await contacts.updateContactAlias(contact.value.uid, aliasDraft.value);
  aliasSaving.value = false;
  if (ok) {
    editingAlias.value = false;
    return;
  }
  aliasError.value = contacts.actionError || '备注名修改失败';
}
</script>
